/* eslint-disable max-len */
type TenantMetaTexts = {
  login: { title: string; description: string };
  signUp: { title: string; description: string };
};

const DEFAULT_TEXTS: TenantMetaTexts = {
    login: {
        title: "Secure login to your Banxe account | Banxe",
        description: "Log in to your Banxe account to manage payments, cards, currency exchange securely from one unified platform.",
    },
    signUp: {
        title: 'Open a Banxe account online | Banxe',
        description: 'Create a Banxe account for business or personal use. Access international payments, cards, currency exchange through one secure platform.',
    },
}

const TENANT_TEXTS: Partial<Record<string, Partial<TenantMetaTexts>>> = {
    com: {
        login: {
            title: "Secure login to your Banxe account | Banxe",
            description: "Log in to your Banxe account to manage payments, cards, currency exchange securely from one unified platform.",
        },
        signUp: {
            title: 'Open a Banxe account online | Banxe',
            description: 'Create a Banxe account for business or personal use. Access international payments, cards, currency exchange through one secure platform.',
        },
    },
    neuronext: {
        login: {
            title: "Secure login to your Neuronext account | Neuronext",
            description: "Log in to your Neuronext account to manage cryptocurrencies, balances and transactions securely in one place.",
        },
        signUp: {
            title: 'Open your Neuronext crypto account | Neuronext',
            description: 'Create a Neuronext account to securely send, receive, exchange and manage cryptocurrencies through one trusted platform.',
        },
    },
}

export function getTenantMetaText<K extends keyof TenantMetaTexts>(
    tenantId: string,
    key: K,
): TenantMetaTexts[K] {
    const tenantOverrides = TENANT_TEXTS[tenantId]?.[key]
    return {
        ...DEFAULT_TEXTS[key],
        ...tenantOverrides,
    }
}
